<span class="section-label">{{ label }}</span>
<ng-content></ng-content>
